module.exports = __webpack_public_path__ + "media/product-showcase.18bc66e9.mp4";